import difference from 'lodash/difference';

function getOfferContentIds(curriculumOffer) {
  const childrenIds = curriculumOffer.offers.map(offer => offer.offerId);
  return [curriculumOffer._id, ...childrenIds];
}

function getStateContentIds(states) {
  return states.map(s => s.contentId);
}

export default function getNonCreatedStatesForPath(curriculumOffer, states) {
  const allOfferContentIds = getOfferContentIds(curriculumOffer);
  const allStateContentIds = getStateContentIds(states);

  return difference(allOfferContentIds, allStateContentIds);
}
